var _linearGradient, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgV8Orinoco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "57.4%",
    x2: "9.8%",
    y1: "67.5%",
    y2: "-7.8%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#464646",
    d: "M960 160c489 0 650 378 650 800s-161 800-650 800-650-325-650-800 161-800 650-800z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e8e8",
    d: "M1483 1150a50 50 0 0043-75l-163-282-225 130 131 227h214zm-949 168a50 50 0 0043 75h326v-260H641l-107 185zm329-906a50 50 0 00-87 0L613 694l226 130 131-227-107-185z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#518aec",
    d: "M630 960a330 330 0 11660 0 330 330 0 01-660 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M1285 1018l-265-265 130-62a330 330 0 01135 327zM668 805l447 447a329 329 0 01-155 38 330 330 0 01-330-330 329 329 0 0138-155z",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1110 1160h373a60 60 0 0033-10l-108 190a160 160 0 01-139 80h-159v50l-140-180 140-180v50zM712 990l-187 323a60 60 0 00-8 34l-109-189a160 160 0 01-1-160l80-138-44-25 226-31 86 211-43-25zm346-260L872 407a60 60 0 00-26-24h219a160 160 0 01139 80l79 137 44-25-86 211-226-31 43-25z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV8Orinoco);
export default __webpack_public_path__ + "static/media/v8-orinoco.a75eeb38c8705286db9601fd0fbc9e9b.svg";
export { ForwardRef as ReactComponent };